export default __webpack_public_path__ + "static/media/acess.6bf32f62.svg";